import { Box, Button, Drawer, IconButton, Typography } from '@mui/material';
import { TextStyle } from 'data/FontStyle';
import useWindowsDimension from 'functions/useWindowsDimension';
import { rq } from 'http/apiRoutes';
import { useGet } from 'http/useApi';
import { IEmployeeViewModel } from 'Interfaces/IEmployeeConfig';
import React, { useEffect, useState } from 'react';
import { EmployeeList } from '../../../pages/Companies/EmployeeList';
import { OrderPostTicketContactInfoViewModel } from 'pages/Orders/ViewModels/OrderPostViewModels';

type EmployeeDrawerProps = {
  buttonIcon: React.ReactNode;
  buttonContext: string;
  handleChange: (
    event: React.MouseEvent<HTMLElement>,
    employee: IEmployeeViewModel
  ) => void;
  companyId: string;
};

export const EmployeeDrawer = ({
  buttonIcon,
  buttonContext,
  handleChange,
  companyId,
}: EmployeeDrawerProps) => {
  const { width } = useWindowsDimension();
  const [open, setOpen] = useState(false);
  const [allEmployees, setAllEmployees] = useState<IEmployeeViewModel[]>([]);
  const [filteredEmployees, setFilteredEmployees] = useState<
    IEmployeeViewModel[]
  >([]);
  const [letterFilter, setLetterFilter] = useState('');

  let isEnabled = companyId !== undefined ? true : false;
  const { data: employeeData } = useGet(rq.employees(companyId, isEnabled));

  const handleLocalChange = (
    e: React.MouseEvent<HTMLElement>,
    employee: IEmployeeViewModel
  ) => {
    handleChange(e, employee);
    setOpen(false);
  };

  useEffect(() => {
    if (employeeData) {
      console.log('employeeData', employeeData);
      setAllEmployees(employeeData.allEmployees);
      setFilteredEmployees(employeeData.allEmployees);
    }
  }, [employeeData]);

  useEffect(() => {
    if (letterFilter) {
      const filtered = allEmployees.filter(
        (employee) =>
          employee.name?.charAt(0).toUpperCase() === letterFilter.toUpperCase()
      );
      setFilteredEmployees(filtered);
    } else {
      setFilteredEmployees(allEmployees);
    }
  }, [letterFilter, allEmployees]);

  let buttonWidth = buttonIcon === null ? '100%' : 32;
  let buttonHeight = buttonIcon === null ? 64 : 32;

  return (
    <>
      {buttonIcon === null ? (
        <Button
          disabled={companyId === undefined}
          variant='contained'
          sx={{
            borderRadius: 2,
            backgroundColor: 'rgba(0, 0, 0, 0.2)',
            width: buttonWidth || '100%',
            height: buttonHeight || '100%',
          }}
          onClick={() => setOpen(!open)}
        >
          <Typography
            sx={{
              textTransform: 'uppercase',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              fontWeight: 'bold',
              fontSize: 14,
              letterSpacing: 2,
              color: 'primary.text',
            }}
          >
            {buttonContext}
          </Typography>
        </Button>
      ) : (
        <Box
          sx={[
            TextStyle.buttonBox,
            {
              width: buttonWidth || 32,
              height: buttonHeight || 32,
            },
          ]}
        >
          <IconButton
            sx={{
              p: 0,
              m: 0,
              width: buttonWidth || 18,
              height: buttonHeight || 18,
            }}
            onClick={() => setOpen(!open)}
          >
            {buttonIcon}
          </IconButton>
        </Box>
      )}
      <Drawer anchor={'left'} open={open} onClose={() => setOpen(!open)}>
        <Box sx={{ width: width / 2, backgroundColor: 'primary.main' }}>
          <Box sx={{ display: 'flex' }}>
            {/* <AlphabetSortDrawer
              buttonIcon={<></>}
              buttonContext='companies'
              handleChange={() => {}}
              onLetterChange={(letter: string) => setLetterFilter(letter)}
            /> */}

            <EmployeeList
              handleChange={handleLocalChange}
              employees={filteredEmployees}
            />
          </Box>
        </Box>
      </Drawer>
    </>
  );
};
